import {Migration} from '@mydocma/core/src/lib/migration';
import {IDBPDatabase} from 'idb';
import { MmProjectDbCollections } from '../../mm-project-db-schema';


export const V1: Migration = {

  up(database: IDBPDatabase<unknown>) {
    database.createObjectStore(MmProjectDbCollections.project,  { keyPath: 'Id' });
    database.createObjectStore(MmProjectDbCollections.fields, { keyPath: 'Id' });
    database.createObjectStore(MmProjectDbCollections.classifications);
    database.createObjectStore(MmProjectDbCollections.contacts, { keyPath: 'Id' });
    database.createObjectStore(MmProjectDbCollections.crafts, { keyPath: 'Id' });
    database.createObjectStore(MmProjectDbCollections.keywords, { keyPath: 'Id' });
    database.createObjectStore(MmProjectDbCollections.orders, { keyPath: 'Id' });
    database.createObjectStore(MmProjectDbCollections.statuses, { keyPath: 'Id' });
    database.createObjectStore(MmProjectDbCollections.layouts, { keyPath: 'Id' });
    database.createObjectStore(MmProjectDbCollections.structures, { keyPath: 'Id' });
    database.createObjectStore(MmProjectDbCollections.userDefineds);
    database.createObjectStore(MmProjectDbCollections.faults,  { keyPath: 'uid' });
    const store = database.createObjectStore(MmProjectDbCollections.files,  { keyPath: 'uid' });
    store.createIndex('faultUid', 'faultUid', { unique: false});


  //   const objStore = database.createObjectStore(MydocmaDbCollections.projects);

  //   objStore.createIndex('customerId', 'customerId', {
  //     unique: false,
  //   });

  },

};
